<template>
  <div id="app">
    <main-head></main-head>
    <router-view/>
    <main-footer></main-footer>
  </div>
</template>

<script>
import MainFooter from './components/MainFooter.vue';
import MainHead from './components/MainHead.vue';
export default {
  name: 'App',
  components: { MainHead, MainFooter }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
